/* eslint-disable no-case-declarations */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect, useMemo } from "react";
import { useRouter } from 'next/router'

import styles from './mainContent.module.css'
import FormContainer from './formConatiner'
import consts from './consts';
import StyledToolTip from './styledToolTip'
import CodeVerification from './codeVerification'
import EmailVerified from "./emailVerified";
import CodeVerificationResend from './codeVerificationResend'
import SiteContent from "./siteContent";
import utils from './utils'
import MainPage from "./mainPage";
import CustomizationCTA from "./customizationCTA";
import UpsellCTA from './upsellCTA'
import MockForm from "./mockForm";
import CustomViewContent from "./customViewContent";
import AddBrandCta from "./addBrandCta";
import SignupModal from "./signupModal";
import config from "./config";
import ProductTutorial from "./productTutorial";
import AddExtensionCta from "./addExtensionCta";
import CelebrationScreen from "./celebrationScreen";

import { useStateValue } from '../state';

export default function MainContent({droppedFiles, updateDroppedFiles, decodedFiles, isUploadExpired, deviceType,
  customSiteContent, uploadMessage, isDemoSite, isEmbedded, isExpired, signup, header, footer, uploadId, uploadCompleted}) {
    const RESET_VIEW = "reset view";
    const VERIFY_CODE = "verify-code-tooltip";
    const RESEND_CODE = "resend-code-tooltip";
    const EMAIL_VERIFIED_WITH_QUESTION = "email-verified-tooltip";
    const CUSTOMIZATION_CTA = "customization-cta-tooltip";
    const UPSELL_UPLOAD_LIMIT = "upsell-upload-limit";
    const UPSELL_RECIPIENTS_LIMIT = "upsell-recipients-limits";
    const TRANSFER_LIMIT_EXCEEDED = 'transfer-limit-exceeded';
    const TRANSFER_QUESTION = "transfer-question-tooltip";
    const VALIDATION_TOOLTIP_NO_FILES_ADDED = "validation-no-files-added";
    const VALIDATION_TOOLTIP_NO_USER_EMAIL = "validation-no-user-email";
    const VALIDATION_TOOLTIP_NO_RECIPIENTS_EMAIL = "validation-no-recipients-email";
    const VALIDATION_TOOLTIP_USER_NOT_VERIFIED = "validation-user-not-verified";
    const allValidationViews = [VALIDATION_TOOLTIP_USER_NOT_VERIFIED, VALIDATION_TOOLTIP_NO_FILES_ADDED, VALIDATION_TOOLTIP_NO_RECIPIENTS_EMAIL, VALIDATION_TOOLTIP_NO_USER_EMAIL];

    const [hideContent, updateHideContent] = useState(true || decodedFiles && decodedFiles.length > 0);
    const [tooltipViewState, updateTooltipViewState] = useState(VERIFY_CODE);
    //const [encodedFilePreviews, updateEncodedFilePreviews] = useState(false);
    const [showToolTip, updateShowToolTip] = useState(false);
    const [fileAdded, updateFileAdded] = useState(false);
    const [forceCodeResend, updateForceCodeResend] = useState(true);
    const [showCTA, updateShowCTA] = useState(deviceType === consts.DEVICE_TYPES.DESKTOP);
    const [transferQuestionShowed, updateTransferQuestionShowed] = useState(false);
    const [customizationCTAShowed, updateCustomizationCTAShowed] = useState(false);
    const [brandChangesSaved, updateBrandChangesSaved] = useState(false);
    const [showSignupModal, updateShowSignupModal] = useState(false);
    const [embeddedUpsellCTA, updateEmbeddedUpsellCTA] = useState(null);
    
    const isTransferInProgress = uploadId && uploadCompleted !== null;
    const isDownloadView = (decodedFiles && decodedFiles.length > 0) || isTransferInProgress;
    const isCustomView = isDownloadView && customSiteContent;
    const title = isCustomView ? customSiteContent.title : "";
    const description = isCustomView ? customSiteContent.description : "Secured, reliable and beautiful. It just works.";
    const oneLiner = isCustomView ? customSiteContent.oneLiner : 'File Sharing You Can Trust';
    const coverImage = isCustomView ? customSiteContent.coverImage : null;
    const [
      {uploadedFilePreviews, senderEmail, codeVerificationData, user, formFooterViewState,
        upsellTooltip, currentActiveTab, siteTemplate, validationTooltip, verificationTooltip,
        productTutorial, formResizeMode, showCelebrationScreen},
      dispatch
    ] = useStateValue();

    const router = useRouter();

    useEffect(() => {
      function showBrandOnSavedChanges() {
        let customizationEnabled = getIsCustomizationEnabled();
        if(customizationEnabled) {
          let templateChanged = utils.getLocalStorageItem(consts.LOCAL_STORAGE_KEYS.BRAND_CHANGED);
          if(templateChanged) {
            updateBrandChangesSaved(true);
          }
        }
      }

      window.addEventListener('storage', showBrandOnSavedChanges)
  
      return () => {
        window.removeEventListener('storage', showBrandOnSavedChanges)
      }
    })

      useEffect(() => {
        if(signup) {
          setTimeout(() => {
              updateShowSignupModal(true);
          }, 500);
        }
      }, [])

      useEffect(() => {
        if(!fileAdded) { 
          if(uploadedFilePreviews.previewFiles.length > 0)  {
            updateFileAdded(true); //Toggle this to true only the first time it happens to trigger verification tooltip
          }
        }
        //TODO: FIX CRITICAL BUG: PDF encoding throws an error
       /*   let encodedPreviews = btoa(JSON.stringify(uploadedFilePreviews.previewFiles));
          updateEncodedFilePreviews(encodedPreviews);*/
      }, [uploadedFilePreviews])

      useEffect(() => {
        if(verificationTooltip && verificationTooltip.show) {
          if(senderEmail.isValid) {
            resetTooltip();
          } /*else {
            updateShowToolTip(false); //hide tooltip
          }*/
        }
      }, [senderEmail])

      useEffect(() => {
        if(tooltipViewState === RESET_VIEW) {
          updateTooltipViewState(VERIFY_CODE);
        }
      }, [tooltipViewState])

      useEffect(() => {
        if(formFooterViewState === consts.FORM_FOOTER_VIEW_STATE.UPLOAD_IN_PROGRESS && !user.isLoggedIn && showCTA) {
          //let viewState = currentActiveTab.name === consts.TAB_NAMES.Generate_Link ? TRANSFER_QUESTION : CUSTOMIZATION_CTA;
          let viewState = currentActiveTab.name === consts.TAB_NAMES.Generate_Link && TRANSFER_QUESTION;
          //let delay = currentActiveTab.name === consts.TAB_NAMES.Generate_Link ? 1000 : 5000;
          let delay = currentActiveTab.name === consts.TAB_NAMES.Generate_Link && 1000;
          let timeout = setTimeout(() => showCTAWithDelay(viewState), delay);
          return () => {
            timeout && clearTimeout(timeout);
        }
        }
      }, [formFooterViewState])

      useEffect(() => {
        function closeTooltip() {
          updateShowToolTip(false);
          updateEmbeddedUpsellCTA(null);
        }
        if(upsellTooltip && upsellTooltip.show) {
          updateShowToolTip(true);
          updateTooltipUpsellView();
          let timeout = setTimeout(closeTooltip, 30000);
            return () => {
              clearTimeout(timeout);
          } 
        } else {
          closeTooltip();
        }
      }, [upsellTooltip])

      function updateTooltipUpsellView() {
        switch (upsellTooltip.reason) {
          case consts.UPSELL_REASONS.UPLOAD_LIMIT_EXCEEDED:
            updateTooltipViewState(UPSELL_UPLOAD_LIMIT);
            break;
            case consts.UPSELL_REASONS.RECIPIENTS_NUMBER_EXCEEDED:
              updateTooltipViewState(UPSELL_RECIPIENTS_LIMIT);
              break;
            case consts.UPSELL_REASONS.TRANSFER_LIMIT_EXCEEDED: 
            updateTooltipViewState(TRANSFER_LIMIT_EXCEEDED);
            break;
          default:
            break;
        }
      }

      useEffect(() => {
        function closeTooltip() {
          updateShowToolTip(false);
          //dispatch({ type: 'VALIDATION-TOOLTIP-CHANGED', payload: {show: false, reason: null}});
        }
        if(validationTooltip && validationTooltip.show && deviceType === consts.DEVICE_TYPES.DESKTOP) {
          if(validationTooltip.reason === consts.VALIDATION_TOOLTIP_REASONS.USER_NOT_VERIFIED) {
            dispatch({ type: 'VERIFICATION-TOOLTIP-CHANGED', payload: {show: true}});
            return;
          }
          updateShowToolTip(true);
          updateValidationTooltipView();
          let timeout = setTimeout(closeTooltip, 4000);
            return () => {
              clearTimeout(timeout);
          } 
        } /*else {
          closeTooltip();
        }*/
      }, [validationTooltip])


      useEffect(() => {
      // if(!showToolTip) { //do not re-render if it is already shown
          if(verificationTooltip && verificationTooltip.show && codeVerificationData.status !== consts.CODE_VERIFICATION_STATUS.CODE_SENT) {
            resetTooltip();
          } /*else {
            updateShowToolTip(false); //hide tooltip
          }*/
        //}
      }, [verificationTooltip])
      
      function updateValidationTooltipView() {
        switch (validationTooltip.reason) {
          case consts.VALIDATION_TOOLTIP_REASONS.NO_FILES_ADDED:
            updateTooltipViewState(VALIDATION_TOOLTIP_NO_FILES_ADDED);
            break;
            case consts.VALIDATION_TOOLTIP_REASONS.NO_USER_EMAIL:
              updateTooltipViewState(VALIDATION_TOOLTIP_NO_USER_EMAIL);
              break;
            case consts.VALIDATION_TOOLTIP_REASONS.NO_RECIPIENTS_EMAIL:
              updateTooltipViewState(VALIDATION_TOOLTIP_NO_RECIPIENTS_EMAIL);
              break;
          default:
            break;
        }
      }

      function showCTAWithDelay(viewState) {
        let questionView = [EMAIL_VERIFIED_WITH_QUESTION, TRANSFER_QUESTION].includes(viewState);
        if(questionView && !transferQuestionShowed) {
          updateShowToolTip(true);
          updateTooltipViewState(viewState);
          updateTransferQuestionShowed(true);
      } else if(viewState === CUSTOMIZATION_CTA && !customizationCTAShowed) {
            updateShowToolTip(true);
            updateTooltipViewState(viewState);
            updateCustomizationCTAShowed(true);
      }
    }
      
      function resetTooltip() {
        dispatch({ type: 'CODE-VERIFICATION-STATUS-CHANGED', payload: {...codeVerificationData, status: consts.CODE_VERIFICATION_STATUS.IDLE}});
        //updateForceCodeResend(false);
        updateTooltipViewState(RESET_VIEW);
        updateShowToolTip(true);
      }

      function handleOnVerificationCompletion() {
        updateTooltipViewState(EMAIL_VERIFIED_WITH_QUESTION);
      }

      function handleOnResendCodeClick() {
        updateForceCodeResend(true);
        updateTooltipViewState(VERIFY_CODE);
      }

      function onCodeVerificationInit() {
        let eventData = {from_step: 'file-form', to_step: VERIFY_CODE, user_email: senderEmail.email, is_work_email: utils.isWorkEmail(senderEmail.email)};
        utils.trackFormStepChanged(eventData);
        dispatch({ type: 'CODE-VERIFICATION-STATUS-CHANGED', payload: {...codeVerificationData, status: consts.CODE_VERIFICATION_STATUS.CODE_SENT, verificationMethod: consts.CODE_VERIFICATION_METHODS.EMAIL, forceResend: forceCodeResend}});
        //updateForceCodeResend(false);
      }

      function CodeVerificationResendInit() {
        let resendEventData = {from_step: VERIFY_CODE, to_step: RESEND_CODE, user_email: senderEmail.email, is_work_email: utils.isWorkEmail(senderEmail.email)};
        utils.trackFormStepChanged(resendEventData);
        dispatch({ type:'FOCUS-SENDER-EMAIL-CHANGED', payload: true});
      }

      function handleOnEmailVerifiedClosed() {
        updateShowToolTip(false);
        let timeout;
      /* if(currentActiveTab.name === consts.TAB_NAMES.Generate_Link && !user.isLoggedIn) {
          timeout = setTimeout(() => showCTAWithDelay(CUSTOMIZATION_CTA), 4000);
        }*/
         return () => {
          timeout && clearTimeout(timeout);
        } 
      }

      function renderFilesValidationIcon() {
        return (
          <svg className={styles.tooltipValidationIcon} xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
          <path d="M28.0566 2V10.6667C28.0566 11.2413 28.2849 11.7924 28.6912 12.1987C29.0976 12.6051 29.6487 12.8333 30.2233 12.8333H38.89" stroke="#FF3B4D" strokewidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15.0566 6.33333C15.0566 5.18406 15.5132 4.08186 16.3258 3.2692C17.1385 2.45655 18.2407 2 19.39 2H28.0566L38.89 12.8333V28C38.89 28.637 38.7535 29.2393 38.5065 29.7832M32.39 32.3333H19.39C18.2407 32.3333 17.1385 31.8768 16.3258 31.0641C15.5132 30.2515 15.0566 29.1493 15.0566 28V15L32.39 32.3333Z" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M30.224 32.3332V36.6665C30.224 37.8158 29.7674 38.918 28.9548 39.7306C28.1421 40.5433 27.0399 40.9998 25.8906 40.9998H10.724C9.57469 40.9998 8.47249 40.5433 7.65983 39.7306C6.84717 38.918 6.39063 37.8158 6.39062 36.6665V14.9998C6.39062 13.8506 6.84717 12.7484 7.65983 11.9357C8.47249 11.1231 9.57469 10.6665 10.724 10.6665" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2.05664 2L41.0566 41" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      }

      function renderEmailValidationIcon() {
        return (
          <svg className={styles.tooltipValidationIcon} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path d="M2.05664 14.6667L21.0566 27.3333L40.0566 14.6667L21.0566 2L2.05664 14.6667Z" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M40.0566 14.667V35.7781C40.0566 36.8979 39.6118 37.9718 38.82 38.7637C38.0282 39.5555 36.9542 40.0003 35.8344 40.0003H6.27886C5.15906 40.0003 4.08512 39.5555 3.2933 38.7637C2.50148 37.9718 2.05664 36.8979 2.05664 35.7781V14.667" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2.05664 35.7775L14.7233 23.1108" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M27.3896 23.1108L40.0563 35.7775" stroke="#FF3B4D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      }

      function renderTooltipValidationNoFiles() {
        return(
          <div className={styles.validationTooltipContent}>
              {renderFilesValidationIcon()}
              <span className={styles.tooltipValidationText}>Whoops! you forgot <br/> to add files 🙃</span>
          </div>
        );
      }

      function renderTooltipValidationNoUserEmail() {
        return(
          <div className={styles.validationTooltipContent}>
              {renderEmailValidationIcon()}
              <span className={styles.tooltipValidationText}>Whoops! you forgot <br/> to add your email 😎</span>
          </div>
        );
      }

      function renderTooltipValidationNoRecipients() {
        return(
          <div className={styles.validationTooltipContent}>
              {renderEmailValidationIcon()}
              <span className={styles.tooltipValidationText}>Whoops! you forgot <br/> to add recipients 🤩</span>
          </div>
        );
      }

      function renderTooltipValidationUserNotVerified() {
        return(
          <div className={styles.validationTooltipContent}>
              {renderFilesValidationIcon()}
              <span className={styles.tooltipValidationText}>Whoops! you are <br/> not verified</span>
          </div>
        );
      }

      function renderBellIcon() {
        return(
        <svg className={styles.bellIcon} xmlns="http://www.w3.org/2000/svg" width="90" height="98" viewBox="0 0 90 98" fill="none">
        <path d="M72.6409 62.1445C73.0334 63.6212 73.5811 64.8729 74.2814 65.8945M72.6409 62.1445L72.8617 62.0858L72.641 62.1446C72.641 62.1446 72.6409 62.1446 72.6409 62.1445ZM72.6409 62.1445C71.6327 58.3588 71.6009 53.2227 71.5675 47.8275L71.5672 47.7695V47.7686C71.5298 41.5679 71.4877 34.5767 69.9942 28.4953L69.9942 28.4953C69.7774 27.6112 70.3192 26.7185 71.2016 26.5018L71.2017 26.5018C72.0856 26.2852 72.9788 26.8244 73.1957 27.7089L72.9738 27.7633L74.2814 65.8945M74.2814 65.8945H16.0162C16.7163 64.8729 17.2626 63.6212 17.6567 62.1448L17.6567 62.1446C18.665 58.3536 18.6968 53.2035 18.7303 47.7972L18.7305 47.7696C18.781 39.47 18.8427 30.1337 22.2075 23.0005C24.0962 18.9982 26.9089 16.0302 30.7024 14.0597C34.5 12.0871 39.2933 11.1077 45.1488 11.1077C51.5811 11.1077 56.8197 12.3164 60.7384 14.6808C64.1319 16.7299 66.6261 19.641 68.362 23.5922L68.3621 23.5924C68.7284 24.4244 69.7014 24.8037 70.534 24.4374C71.3663 24.0712 71.7455 23.1006 71.3815 22.2666L71.3812 22.2661C69.394 17.7431 66.3877 14.2393 62.444 11.8577L62.4439 11.8576C59.9692 10.3647 57.0763 9.28326 53.7951 8.61528C53.3663 4.21947 49.6542 0.771519 45.1488 0.771519C40.6436 0.771519 36.9314 4.21927 36.5062 8.61335C33.3768 9.2487 30.6009 10.2588 28.2082 11.6465C24.2878 13.9184 21.264 17.2675 19.2233 21.5904L19.2233 21.5905C15.5437 29.3905 15.4842 39.1581 15.432 47.7196L15.4319 47.7444C15.4 52.9979 15.3686 57.9147 14.4687 61.2916L14.4687 61.2917C14.0296 62.9403 13.435 64.0834 12.638 64.8155C11.8474 65.5417 10.8326 65.8862 9.50072 65.8871H9.49527C4.77989 65.889 0.943394 69.7241 0.943394 74.4381C0.943394 79.1522 4.7799 82.9873 9.49527 82.9873H24.1611H29.7814C30.6073 90.7355 37.1823 96.7918 45.1488 96.7918C53.1154 96.7918 59.6885 90.7355 60.5144 82.9873H80.8005C85.5159 82.9873 89.3524 79.1522 89.3524 74.4381C89.3524 69.7241 85.5159 65.8889 80.8005 65.8889H80.7951C79.4632 65.888 78.4479 65.5435 77.6571 64.8173C76.8599 64.0853 76.2653 62.9422 75.8272 61.2936L75.6063 61.3523L74.2814 65.8945ZM4.2383 74.4363C4.2383 71.5389 6.59669 69.1829 9.49355 69.1811H9.49901H80.7931H80.7987H80.8005C83.6971 69.1811 86.0556 71.5388 86.0556 74.4363C86.0556 77.3337 83.6972 79.6915 80.7987 79.6915H34.7941H24.1611H9.49527C6.59674 79.6915 4.2383 77.3337 4.2383 74.4363ZM45.1488 93.4959C39.0024 93.4959 33.9097 88.9137 33.1019 82.9873H34.7941H57.194C56.388 88.9137 51.2935 93.4959 45.1488 93.4959ZM45.1488 4.06738C47.6462 4.06738 49.7534 5.77565 50.3612 8.08466C48.7049 7.90211 46.9695 7.80625 45.1488 7.80625C43.3285 7.80625 41.5915 7.90043 39.9366 8.08277C40.5444 5.77555 42.6516 4.06738 45.1488 4.06738Z" fill="#EA3989" stroke="#EA3989" strokeWidth="0.456962"/>
        <path d="M67.832 10.1058L67.8319 10.106L67.8417 10.1109C67.8417 10.1109 67.842 10.1111 67.8427 10.1115C67.8991 10.1441 70.3675 11.5699 72.8015 14.8489L72.8015 14.8489C76.0982 19.2899 77.777 24.8449 77.777 31.3728C77.777 32.283 78.516 33.0217 79.4263 33.0217C80.3366 33.0217 81.0756 32.283 81.0756 31.3728C81.0756 22.2736 77.9672 16.2257 75.3501 12.7499C72.4777 8.93318 69.5757 7.30149 69.4362 7.22423L69.4362 7.22423L69.4356 7.22394C68.6405 6.78643 67.6434 7.07228 67.2012 7.86492C66.7545 8.65888 67.0414 9.66186 67.832 10.1058Z" fill="#EA3989" stroke="#EA3989" strokeWidth="0.456962"/>
        <path d="M78.0443 8.34362L78.0443 8.34362L78.6583 10.4273C78.886 10.5766 84.2539 14.177 84.2539 23.2369C84.2539 24.0208 84.8905 24.6554 85.6747 24.6554C86.4589 24.6554 87.0937 24.0208 87.0937 23.2369C87.0937 12.5513 80.4731 8.2155 80.1893 8.03632L80.312 7.84363C80.3119 7.84354 80.3118 7.84346 80.3116 7.84338C79.5456 7.35559 78.5355 7.58211 78.0443 8.34362Z" fill="#EA3989" stroke="#EA3989" strokeWidth="0.456962"/>
        <path d="M23.1092 7.86945L23.1091 7.86926C22.6671 7.07229 21.6658 6.78402 20.8684 7.22378L20.868 7.22397C20.7285 7.30122 17.8265 8.93291 14.9541 12.7496C12.337 16.2254 9.22855 22.2752 9.22855 31.3725C9.22855 32.2823 9.96533 33.0214 10.876 33.0214C11.7863 33.0214 12.5253 32.2827 12.5253 31.3725C12.5253 24.8446 14.2041 19.2897 17.5008 14.8486C19.9189 11.5915 22.374 10.1604 22.4697 10.1048C23.2611 9.6625 23.5491 8.6645 23.1092 7.86945Z" fill="#EA3989" stroke="#EA3989" strokeWidth="0.456962"/>
        <path d="M6.27533 23.239C6.27533 24.1491 5.53816 24.886 4.62787 24.886C3.71778 24.886 2.97855 24.1475 2.97855 23.239C2.97855 12.4441 9.67243 8.04678 9.98878 7.84568L6.27533 23.239ZM6.27533 23.239C6.27533 14.3028 11.5542 10.7602 11.7667 10.6211M6.27533 23.239L11.7667 10.6211M11.7667 10.6211C12.5292 10.1311 12.7521 9.11535 12.2647 8.35067C11.7768 7.58347 10.7581 7.35615 9.9889 7.84561L11.7667 10.6211Z" fill="#EA3989" stroke="#EA3989" strokeWidth="0.456962"/>
        </svg>
        );
      }

      const renderToolTipViewByState = () => {
        { 
            switch (tooltipViewState) {
                case VERIFY_CODE:
                 return <CodeVerification show={true} onInit={onCodeVerificationInit} 
                 onCompletion={handleOnVerificationCompletion}
                 onResendClick={() => updateTooltipViewState(RESEND_CODE)} senderEmail={senderEmail.email}
                 lineProgressBarStyle={{ bottom: '-34px'}} onGetLink={() => updateShowToolTip(false)} showSMSVerification={true}/>;
                 case RESEND_CODE:
                  return <CodeVerificationResend onInit={CodeVerificationResendInit} show={true} onButtonClick={handleOnResendCodeClick}
                   onBack={() => updateTooltipViewState(VERIFY_CODE)} onGetLink={() => {
                     resetTooltip();
                     updateShowToolTip(false);
                    }}/>;
                  case EMAIL_VERIFIED_WITH_QUESTION:
                    let verifiedEventData = {from_step: VERIFY_CODE, to_step: EMAIL_VERIFIED_WITH_QUESTION, user_email: senderEmail.email, is_work_email: utils.isWorkEmail(senderEmail.email)};
                    utils.trackFormStepChanged(verifiedEventData);
                    return <EmailVerified show={true} email={senderEmail.email} userId={user.userId} onClose={handleOnEmailVerifiedClosed}/>;
                    case TRANSFER_QUESTION:
                      let questionEventData = {from_step: 'link-form', to_step: TRANSFER_QUESTION, user_email: "", is_work_email: false};
                      utils.trackFormStepChanged(questionEventData);
                      return <EmailVerified showQuestionOnly={true} show={true} email={senderEmail.email} userId={user.userId} onClose={handleOnEmailVerifiedClosed}/>;
                  case CUSTOMIZATION_CTA:
                    return <CustomizationCTA show={true} onClose={() => updateShowToolTip(false)}/>;
                  case UPSELL_UPLOAD_LIMIT:
                    let uploadLimitCta = <UpsellCTA show={true} text={user.isLoggedIn ? 'Upgrade now' : 'Try it for Free'}
                            openInNewTab={isEmbedded}
                            linkUrl={user.isLoggedIn  ? `/posts/pricing/?source=upsell-cta-${UPSELL_UPLOAD_LIMIT}: ""}` : `/posts/signup/?source=upsell-cta-${UPSELL_UPLOAD_LIMIT}`} onClose={() => updateShowToolTip(false)} reason={UPSELL_UPLOAD_LIMIT} openInNewTab={!user.isLoggedIn}>
                             <span className={styles.upsellCtaTitle}>Goin' wild, are we?</span>
                             <span className={styles.upsellCtaText}>{`You can send up to ${utils.bytesToSize(upsellTooltip.currentLimit)}`} <br/>at a time on this account.<br/>Upgrade and get 50GB per transfer</span>
                            </UpsellCTA>
                            if(isEmbedded) {
                              updateEmbeddedUpsellCTA(uploadLimitCta);
                              break;
                            } else {
                              return uploadLimitCta;
                            }
                  case UPSELL_RECIPIENTS_LIMIT:
                    let recipientsLimitCta =  <UpsellCTA show={true} text={user.isLoggedIn ? 'Upgrade now' : 'Try it for Free'}
                             openInNewTab={isEmbedded}
                             linkUrl={user.isLoggedIn  ? `/posts/pricing/?source=upsell-cta-${UPSELL_UPLOAD_LIMIT}: ""}` : `/posts/signup/?source=upsell-cta-${UPSELL_RECIPIENTS_LIMIT}`} onClose={() => updateShowToolTip(false)} reason={UPSELL_RECIPIENTS_LIMIT}>
                             <span className={styles.upsellCtaTitle}>Goin' wild, are we?</span>
                             <span className={styles.upsellCtaText}>{`You can send up to ${upsellTooltip.currentLimit}`} <br/>recipients on this account.<br/>Upgrade and get up to 100 recipients</span>
                             </UpsellCTA>
                    if(isEmbedded) {
                      updateEmbeddedUpsellCTA(recipientsLimitCta);
                      break;
                    } else {
                      return recipientsLimitCta;
                    }     
                  case TRANSFER_LIMIT_EXCEEDED:
                      let transfersLimitCta = <UpsellCTA show={true} hideCloseIcon={true}
                      text={'Upgrade now'}
                      openInNewTab={isEmbedded}
                      linkUrl={user.isLoggedIn  ? `/posts/pricing/?source=upsell-cta-${TRANSFER_LIMIT_EXCEEDED}: ""}` : `/posts/signup/?source=upsell-cta-${TRANSFER_LIMIT_EXCEEDED}`}
                      reason={TRANSFER_LIMIT_EXCEEDED} customIcon={renderBellIcon()} buttonStyle={{background: "#EA3989", borderRadius: '36.0785px'}}>
                      <span className={styles.transferLimitExceededTitle}>No more transfers</span>
                      <span className={styles.upsellCtaText}>{`You can make up to ${upsellTooltip.currentLimit}`} <br/> transfers per month on your plan.<br/>Upgrade to unlock unlimited transfers</span>
                      </UpsellCTA>  
                      if(isEmbedded) {
                        updateEmbeddedUpsellCTA(transfersLimitCta);
                        break;
                      } else {
                        return transfersLimitCta;
                      }         
                  case VALIDATION_TOOLTIP_NO_FILES_ADDED:
                   return renderTooltipValidationNoFiles();
                  case VALIDATION_TOOLTIP_NO_RECIPIENTS_EMAIL:
                    return renderTooltipValidationNoRecipients();
                  case VALIDATION_TOOLTIP_NO_USER_EMAIL:
                    return renderTooltipValidationNoUserEmail();
                }
            }
    }

    const handleMobileSendFilesOnClick = (e) => {
      //Hide the send files button after a click
      e.target.style.visibility = 'hidden';
      //update the sate to hide the main content and show the upload files form
      //one day I will know responsive css :(
      updateHideContent(true);
    }

    const styledToolTip = () => {
      let showComponent = tooltipViewState === RESEND_CODE || showToolTip && senderEmail.email != '' && senderEmail.isValid && deviceType === consts.DEVICE_TYPES.DESKTOP;
      const shouldRenderView = showComponent || (showToolTip && upsellTooltip.show)|| (showToolTip && validationTooltip.show) ||(showToolTip && currentActiveTab.name === consts.TAB_NAMES.Generate_Link);
      let customTooltipStyle;
      let customTooltipPointerStyle;
      if(allValidationViews.includes(tooltipViewState)) {
         customTooltipStyle = validationTooltip && validationTooltip.customTooltipStyle && validationTooltip.customTooltipStyle.container;
         customTooltipPointerStyle = validationTooltip && validationTooltip.customTooltipStyle &&  validationTooltip.customTooltipStyle.pointer;
      } 
      return (
        <StyledToolTip tooltipStyle={{...customTooltipStyle, position: 'absolute', left: isEmbedded ? '36px' : '330px', top: isEmbedded ? '11vh' : customTooltipStyle && customTooltipStyle.top, minHeight: isEmbedded ? '437px' : customTooltipStyle && customTooltipStyle.minHeight}} tooltipContentStyle={{paddingTop: tooltipViewState === VERIFY_CODE && '18px'}}
        pointerStyle={{...customTooltipPointerStyle, ...{display: isEmbedded && 'none'}}}
        show={ !isEmbedded && ((showComponent && !user.isLoggedIn) || (showToolTip && upsellTooltip.show) || (showToolTip && validationTooltip.show) || (showToolTip && currentActiveTab.name === consts.TAB_NAMES.Generate_Link))}
        shouldRenderPointer={!(codeVerificationData.status === consts.CODE_VERIFICATION_STATUS.SUCCESSFUL)} fadeOut={false}>
           {shouldRenderView && renderToolTipViewByState()}
         </StyledToolTip>
      );
    }

    const formContainer = () => {
      return (
        <FormContainer showForm={hideContent} droppedFiles = {droppedFiles}
        updateDroppedFiles = {updateDroppedFiles} decodedFilesForDownload = {decodedFiles} isUploadExpired = {isUploadExpired}
        deviceType={deviceType} isCustomView={isCustomView} uploadMessage={uploadMessage} isEmbedded={isEmbedded} embeddedUpsellCTA={embeddedUpsellCTA}/> 
      );
    }

    const memoizedToolTip = useMemo(() => styledToolTip() , [showToolTip, codeVerificationData, tooltipViewState, senderEmail, deviceType, validationTooltip]);
    const memoizedForm = useMemo(() => formContainer() , [hideContent, droppedFiles, updateDroppedFiles, decodedFiles, isUploadExpired, deviceType, isCustomView, isEmbedded, embeddedUpsellCTA]);

      function renderHomePageContent() {
      let showNewUserContent = deviceType === consts.DEVICE_TYPES.DESKTOP &&!isCustomView && !user.isLoggedIn;
      let isEmbeddedMinimizedView = isEmbedded && (formFooterViewState === consts.FORM_FOOTER_VIEW_STATE.UPLOAD_IN_PROGRESS || formFooterViewState === consts.FORM_FOOTER_VIEW_STATE.CANCEL_UPLOAD) && formResizeMode === consts.FORM_RESIZE_MODE.MINIMIZED;
      let hasUnlimitedTransfers = user.monthlyTransfersLimit == consts.FEATURE_NAMES.UNLIMITED_TRANSFERS;
      return (
        <MainPage form={isDemoSite ? <MockForm normalScale formStyle={{width: '280px', height: '400px'}}
        formColor={siteTemplate.complementaryColor}/> : memoizedForm} toolTip={memoizedToolTip}
        showPoweredBy={decodedFiles && decodedFiles.length > 0}
        header={header} footer={footer}
        containerClass={isEmbeddedMinimizedView ? 'embeddedMinimizedContainer' : hasUnlimitedTransfers && 'embeddedWithoutUpgradeContainer'}
        showUpgradeMessage={isEmbedded && !isEmbeddedMinimizedView && !hasUnlimitedTransfers}
        applyEmbeddedStyle={isEmbedded}
        >
        {!((formFooterViewState === consts.FORM_FOOTER_VIEW_STATE.UPLOAD_IN_PROGRESS || formFooterViewState === consts.FORM_FOOTER_VIEW_STATE.CANCEL_UPLOAD) && isEmbedded && formResizeMode === consts.FORM_RESIZE_MODE.MINIMIZED)
        && <SiteContent siteTitle={title} siteDescription={description} siteOneLiner={oneLiner}
        wrapperStyle={{display: (isEmbedded && !hasUnlimitedTransfers) ? 'none' : 'block', flexGrow: '3',
        marginTop: deviceType === consts.DEVICE_TYPES.DESKTOP ? (coverImage != null && '39vh') : (coverImage != null ? '16vh' : 'unset'), width: '100%'}}
        hideContent={hideContent}
        onMobileSendClick={handleMobileSendFilesOnClick}
        descriptionStyle={isCustomView ? {paddingTop:deviceType === consts.DEVICE_TYPES.DESKTOP ? '0px' : '13px', fontWeight: '600', position: 'relative', bottom: '7px', margin: '0', marginTop: '25px'} : null}
        contentWrapperClassName={isCustomView && 'contentWrapperCustomPage'}
        showCtaContainer={showNewUserContent}
        ctaButtonText={"Get Your Custom Page"}
        ctaButtonLink={'/posts/signup/?source=home-page-cta'}
        ctaButtonClassName='addYourBrand'
        coverImage={coverImage}
        coverImageClassName='coveImageSite'
        showBrandPreview={false}
        descriptionClassName={!isCustomView && 'homePageDescription'}
        hideDefaultText={true}
        showTrialMessage={!isEmbedded}
        />}
       </MainPage>
        );
      }

      function renderLoggedInScreen() {
        let customizationEnabled = getIsCustomizationEnabled();
        let userHasPublishedEnabledTemplate = customizationEnabled && user.hasPublishedTemplate;
        let showBrandPreview = userHasPublishedEnabledTemplate || brandChangesSaved;
        let showProductTutorial = productTutorial.show && !showBrandPreview;
        let showUpgradeMessage = !showProductTutorial && (user && user.trialInfo && user.trialInfo.onTrial || !user.planInfo.isPaidPlan || !user.isPaying || user.monthlyTransfersLimit  < consts.FEATURE_NAMES.UNLIMITED_TRANSFERS )
        let userName = user.userName.split(" ")[0];
        return (
          <MainPage showTitle={!(showProductTutorial || showCelebrationScreen)} form={memoizedForm} toolTip={memoizedToolTip}
          showUpgradeMessage={showUpgradeMessage} header={header} footer={footer}
          containerClass={showProductTutorial ? 'tutorialContainer' : showCelebrationScreen ? 'celebrationContainer' : !showUpgradeMessage ? 'homePageContainerPaid' : null}
          homePageWrapperClass={showCelebrationScreen ? 'celebrationPageWrapper' : showProductTutorial ? 'tutorialPageWrapper' : null} userName={userName}>
            <SiteContent siteTitle={''} siteDescription={showProductTutorial && !showCelebrationScreen ? 'Let’s Send your first files!  🚀' : ""} siteOneLiner={!showCelebrationScreen && `Welcome, ${userName}`}
            hideContent={false}
            userId={user.userId}
            ctaButtonClassName='addYourBrand'
            ctaButtonText={customizationEnabled ? 'Add Your Brand' : 'Upgrade to add your brand '}
            ctaButtonLink={customizationEnabled ? `/posts/brand-editor?userId=${user.userId}` : `/posts/pricing/?source=user-homepage-cta`}
            showBrandPreview={showBrandPreview}
            coverImage={!siteTemplate.isDemoTemplate && siteTemplate.coverImage}
            openCtaInSameTab={true}
            showCoverImage={false}
            descriptionStyle={!showProductTutorial ? {display: 'none'} : {}}
            customContentRenderer={showCelebrationScreen ? () => <CelebrationScreen title={`You did it, ${user.userName.split(" ")[0]}!`} description={<span>Congrats! You're officially a file driver. With great <br/> power comes great responsibility. Drive Safe ⭐️</span>}/> : showProductTutorial ? () => <ProductTutorial/> : !showBrandPreview ? () => {return !user.isExtensionInstalled ? <AddExtensionCta/> : <AddBrandCta Url={customizationEnabled ? `/posts/brand-editor?userId=${user.userId}` : `/posts/pricing/?source=user-homepage-cta`} CtaText={customizationEnabled ? 'Create your page' : 'Upgrade & create your page'} showArrow={customizationEnabled}/>} : null }
        />
          </MainPage>
            );
      }

      function getIsCustomizationEnabled() {
        let customizationFeature = user && user.enabledFeatures && user.enabledFeatures.find(i => i.name == consts.FEATURE_NAMES.BRAND_CUSTOMIZATION);
        let customizationEnabled = customizationFeature && customizationFeature.value === 'enabled';
        return customizationEnabled;
      }

      function renderCustomViewContent() {
        let applyMobileStyle =  deviceType === consts.DEVICE_TYPES.MOBILE;
        let applyDemoStyle = isDemoSite;
        return (
          <CustomViewContent header={header} footer={footer}
          form={isDemoSite ? <MockForm normalScale formStyle={{width: '280px', height: '400px'}}
          formColor={siteTemplate.complementaryColor}/> : memoizedForm} toolTip={memoizedToolTip}
          showPoweredBy={false} isDemo={isDemoSite}>
          <SiteContent siteTitle={title} siteDescription={description} siteOneLiner={oneLiner}
          wrapperStyle={{marginTop:applyMobileStyle ? '16vh' : isDemoSite ? '6vh' : '30vh', marginLeft: (!applyMobileStyle && !isDemoSite) && '28vw'}}
          hideContent={hideContent}
          descriptionStyle={{paddingTop:'0px', fontWeight: '600', position: 'relative', bottom: deviceType === consts.DEVICE_TYPES.DESKTOP && '7px', margin: deviceType === consts.DEVICE_TYPES.DESKTOP ? '0' : '5px', marginTop: deviceType === consts.DEVICE_TYPES.DESKTOP ? '25px' : '5px'}}
          contentWrapperClassName={'contentWrapperCustomPage'}
          contentWrapperStyle={{top: coverImage === null && '42vh'}}
          showCtaContainer={false}
          ctaButtonText={"Get Your Custom Page"}
          ctaButtonLink={'/posts/signup/?source=home-page-cta'}
          ctaButtonClassName='addYourBrand'
          coverImage={coverImage}
          coverImageClassName='coveImageSite'
          showBrandPreview={false}
          hideDefaultText={true}
          ignoreLoggedInUser={true}
          />
          </CustomViewContent>
          );
      }

      function renderDownloadView() {
        return (
          <MainPage form={memoizedForm} toolTip={memoizedToolTip} showPoweredBy={decodedFiles && decodedFiles.length > 0}
          header={header} containerClass={'defaultDownloadContainer'}
          homePageWrapperClass={'defaultDownloadPageWrapper'} centerContentClass={'defaultDownloadPageCenterContent'}>
          <SiteContent siteTitle={title} siteDescription={description} siteOneLiner={oneLiner}
          wrapperStyle={{marginTop: deviceType === consts.DEVICE_TYPES.DESKTOP ? (coverImage != null && '39vh') :
          (coverImage != null ? '16vh' : 'unset'), width: '100%'}}
          hideContent={hideContent}
          descriptionStyle={null}
          showCtaContainer={true}
          ctaButtonText={"Get Your Custom Page"}
          ctaButtonLink={'/posts/signup/?source=home-page-cta'}
          ctaButtonClassName='addYourBrand'
          coverImage={coverImage}
          coverImageClassName='coveImageSite'
          showBrandPreview={false}
          descriptionClassName={'homePageDescription'}
          hideDefaultText={true}
          ignoreLoggedInUser={true}
          showTrialMessage={false}
          />
         </MainPage>
          );
      }

      function getViewToRender() {
        let shouldCompletePurchase = utils.getSessionStorageItem(consts.SESSION_STORAGE_KEYS.COMPLETE_PURCHASE);
        if(shouldCompletePurchase === 'true') {
          window.location.assign('/posts/pricing/?source=complete-purchase')
        } else if(user.isLoggedIn && !user.completedOnboarding && config.ONBOARDING_ENABLED && !(window.location.pathname === '/posts/onboarding/extension-onboarding')) { //do not change the screen if the user is in the middle of an extension onboarding
          let url = `/posts/onboarding`;
          if(isEmbedded) {
            window.open(url, '_blank');
            parent.postMessage('close', '*');
          } else {
            router.push(url);
          }
        } else
        if(user.isLoggedIn && !(isDownloadView || isExpired) && !isEmbedded) {  //Do not show the logged screen when download page is presented
          return renderLoggedInScreen();
        } else if(isCustomView) {
          return renderCustomViewContent();
        }
          else if(isDownloadView || isExpired) {
            return renderDownloadView();
        } else {
          return deviceType === consts.DEVICE_TYPES.MOBILE && renderHomePageContent(); //only mobile/embedded currently supports non-logged in users (which are not download users)
        }
      }

    return (
      <div className={styles.container}>
          {getViewToRender()}
          {showSignupModal && <SignupModal/>}
      </div>
      
    )
  }